var map = {
	"./app-icon.svg": 1742,
	"./caret-right-icon.svg": 1743,
	"./chrome-icon.webp": 1744,
	"./edge-icon.webp": 1745,
	"./firefox-icon.webp": 1746,
	"./opera-icon.webp": 1747,
	"./safari-icon.webp": 1748,
	"./unknown-icon.webp": 1749
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1741;